const TiposGestao = [
    { cod: "01", descricao: "Cancelamento de chamado"},
    { cod: "02", descricao: "Troca de SAP "},
    { cod: "03", descricao: "Corte de unidade"},
    { cod: "04", descricao: "Análise de unidade específica"},
    { cod: "05", descricao: "Sem unidade"},
    { cod: "06", descricao: "Análise de informações no TA com a gestão"},
    { cod: "07", descricao: "Análise de quantidade solicitada"},
    { cod: "08", descricao: "Unidade em reserva técnica (Unidade não utilizada para atendimento)"},
    { cod: "09", descricao: "Encaminhado para gestão por solicitação Vivo"},
    { cod: "10", descricao: "Encerramento Técnico"},
  ];

  // Função para obter a descrição com base no código
  export const getDescricaoByCod = (cod) => {
    const motivo = TiposGestao.find((item) => item.cod === cod);
    return motivo ? motivo.descricao : "Descrição não encontrada";
  };

  export default TiposGestao